<template>
    <div>
        <div>
            <v-row class="appointment-row">
                <v-col class="appointment-time-col d-flex justify-center align-center no-padding-top no-padding-bottom">
                    {{getBeginingFromAppointments(appointment)}}&nbsp;{{$t('appointment.until')}}<br>
                    {{getEndFromAppointments(appointment)}}&nbsp;{{$t('appointment.time')}}
                </v-col>
                <v-col class="appointment-name-col d-flex flex-column justify-center no-padding-top no-padding-bottom">
                    <div class="appointment-name">{{appointment.name}}</div>
                    <div>{{appointment.location}}</div>
                </v-col>
            </v-row>
        </div>
        <v-row v-if="length === 2 && index==2" class="empty-appointment"></v-row>
        <v-row v-if="length === 1 && index==1" class="empty-appointment"></v-row>
    </div>
</template>
<style lang="scss">
.appointment-row{
    min-height: 13vh;
    height: 13vh;
    max-height: 13vh;
}
.appointment-time-col{
    font: normal normal normal 3vh/4vh 'RobotoRegular' !important;
    color: $font-color !important;
    flex-grow: 1;
}
.appointment-name-col{
    font: normal normal normal 3vh/4vh 'RobotoRegular' !important;
    color: $font-color !important;
    flex-grow: 8;
}
.appointment-name{
    font: normal normal Bold 4vh/5vh 'RobotoRegular' !important;
}
.hide {
    opacity: 0;
}
</style>
<script>
import moment from 'moment';
export default {
    props: {
        appointment: {
            type: Object,
            required: true,
        },
        index: {
            type: Number,
            required: true
        },
        length: {
            type: Number,
            required: true
        },
    },
    methods: {
        getBeginingFromAppointments(appointment) {
            return moment(appointment.begin).format('HH:mm');
        },
        getEndFromAppointments(appointment) {
            return moment(appointment.end).format('HH:mm');
        },
    },
}
</script>
